export default __webpack_public_path__ + "static/media/Smartphone.adcb05c9.png";